/* eslint-disable max-lines */
/* eslint-disable max-len */
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {addMessageBoxError, addMessageBoxInfo} from '../../common/messageBox/actions/actions';

export const fetchOrigins = () =>
  apiActionCreator({
    'endpoint': '/manage-orders/params/get',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ORIGINS,
      ActionTypes.FETCHED_ORIGINS,
      [ActionTypes.FETCHED_ORIGINS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchAddOrEditOrigin = (originObject) => {
  return apiActionCreator({
    'endpoint': '/manage-orders/params/post',
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_ORIGINS,
      ActionTypes.ADDED_ORIGINS,
      [ActionTypes.ADD_ORIGINS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'POST',
    'data': {
      ...originObject,
      'arrival_time': parseInt(originObject.arrival_time, 10),
      'country': originObject.country.toUpperCase(),
    },
    'contentType': 'application/json',
  });
};

export const fetchDeleteOrigin = (country) =>
  apiActionCreator({
    'endpoint': `/manage-orders/params/${country}`,
    'authenticated': true,
    'types': [
      ActionTypes.DELETING_ORIGINS,
      ActionTypes.DELETED_ORIGINS,
      [ActionTypes.DELETE_ORIGINS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'DELETE',
  });

export const fetchProviders = () =>
  apiActionCreator({
    'endpoint': '/providers',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PROVIDERS,
      ActionTypes.FETCHED_PROVIDERS,
      [
        ActionTypes.FETCHED_PROVIDERS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchValidateXLXSOrderFile = (requestObject) => {
  return apiActionCreator({
    'endpoint': '/vehicles/validateOrderVehicleArray',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_XLXS_ORDER_FILE,
      ActionTypes.FETCHED_XLXS_ORDER_FILE,
      [
        ActionTypes.FETCH_XLXS_ORDER_FILE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'data': requestObject,
    'contentType': 'application/json',
  });
};

export const fetchGenerateOrder = (requestObject) => {
  return apiActionCreator({
    'endpoint': '/vehicles/orderVehicle',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_CREATE_HEADER_AND_DATA,
      [
        ActionTypes.FETCHED_CREATE_HEADER_AND_DATA,
        addMessageBoxInfo('La orden se ha generado exitosamente.'),
      ],
      [
        ActionTypes.FETCH_CREATE_HEADER_AND_DATA_FALIED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'data': requestObject,
    'contentType': 'application/json',
  });
};

export const fetchGetOriginsMenu = () =>
  apiActionCreator({
    'endpoint': '/vehicles/get-menu-orders',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ORIGINS_MENU,
      ActionTypes.FETCHED_ORIGINS_MENU,
      [
        ActionTypes.FETCH_ORIGINS_MENU_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchGetOriginData = (orderNumber) =>
  apiActionCreator({
    'endpoint': `/vehicles/get-all-order/${orderNumber}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ALL_DATA_ORIGINS,
      ActionTypes.FETCHED_ALL_DATA_ORIGINS,
      [
        ActionTypes.FETCH_ALL_DATA_ORIGINS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchUpdateOrderData = (orderNumber, requestObject) =>
  apiActionCreator({
    'endpoint': `/vehicles/get-all-order/${orderNumber}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ADD_ALL_DATA_ORIGINS,
      [
        ActionTypes.FETCHED_ADD_ALL_DATA_ORIGINS,
        addMessageBoxInfo('Se ha actualizado exitosamente.'),
      ],
      [
        ActionTypes.FETCH_ADD_ALL_DATA_ORIGINS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': requestObject,
    'contentType': 'application/json',
  });

export const fetchSelectModelTempOrders = (countryCode) =>
  apiActionCreator({
    'endpoint': `/vehicles/get-select-catalog/all-models?country=${countryCode}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ALL_MODELS_CATALOG,
      ActionTypes.FETCHED_ALL_MODELS_CATALOG,
      [
        ActionTypes.FETCH_ALL_MODELS_CATALOG_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchAddTempOrders = (requestObject) => {
  return apiActionCreator({
    'endpoint': '/vehicles/add-new-order',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ADD_TEMP_ORDER,
      [
        ActionTypes.FETCHED_ADD_TEMP_ORDER,
        addMessageBoxInfo('La orden se ha generado exitosamente.'),
      ],
      [
        ActionTypes.FETCH_ADD_TEMP_ORDER_FALIED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'data': requestObject,
    'contentType': 'application/json',
  });
};

export const fetchGetTempOrderColor = (katashiki, sfx, setColor) => {
  return apiActionCreator({
    'endpoint': `/master-vehicles/vehicle-color-combination/${katashiki}/${sfx}`,
    'authenticated': true,
    'types': [
      [ActionTypes.DUMMY_ACTION],
      [
        (response) => {
          setColor(response.data);
          return {
            'type': ActionTypes.DUMMY_ACTION,
          };
        },
      ],
      [ActionTypes.DUMMY_ACTION, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchGetTempOrderPrice = (data, setPrice) => {
  return apiActionCreator({
    'endpoint': `/vehicles/get-select-catalog/prices?order_number=${data.orderNumber}&katashiki=${data.model}&sfx=${data.sfx}&outdoor_color=${data.outColor}&indoor_color=${data.inColor}`,
    'authenticated': true,
    'types': [
      [ActionTypes.DUMMY_ACTION],
      [
        (response) => {
          setPrice(response.data);
          return {
            'type': ActionTypes.DUMMY_ACTION,
          };
        },
      ],
      [ActionTypes.DUMMY_ACTION, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};


export const fetchGetShipmentHeader = (item, shipment) => {
  return apiActionCreator({
    'endpoint': `/vehicles/shipment-header?item=${item}&shipment=${shipment}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_GET_SHIPMENT_HEADER,
      ActionTypes.FETCHED_GET_SHIPMENT_HEADER,
      [
        ActionTypes.FETCH_GET_SHIPMENT_HEADER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchGetShipmentData = (orderNumber) => {
  return apiActionCreator({
    'endpoint': `/vehicles/shipments-data?order_number=${orderNumber}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_GET_SHIPMENT_DATA,
      ActionTypes.FETCHED_GET_SHIPMENT_DATA,
      [
        ActionTypes.FETCH_GET_SHIPMENT_DATA_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchPostShipmentHeader = (requestObject) => {
  return apiActionCreator({
    'endpoint': '/vehicles/shipment-header',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_POST_SHIPMENT_DATA,
      [
        ActionTypes.FETCHED_POST_SHIPMENT_DATA,
        (response) => {
          if (response.data?.error) {
            return addMessageBoxError(response.data?.message);
          }
          return addMessageBoxInfo('La orden se ha generado exitosamente.');
        },
      ],
      [
        ActionTypes.FETCH_POST_SHIPMENT_DATA_FALIED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'data': requestObject,
    'contentType': 'application/json',
  });
};

export const fetchGetOrderSummary = (orderNumber) => {
  return apiActionCreator({
    'endpoint': `/vehicles/order-summary?order_number=${orderNumber}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_GET_ORDER_SUMMARY,
      ActionTypes.FETCHED_GET_ORDER_SUMMARY,
      [
        ActionTypes.FETCH_GET_ORDER_SUMMARY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const setHeaderValues = (headerObject) => ({
  'type': ActionTypes.SET_HEADER_VALUE,
  'payload': headerObject,
});

export const cleanHeaderValues = () => ({
  'type': ActionTypes.CLEAN_HEADER_VALUE,
  'payload': null,
});

export const activateOrigin = (originObject) => ({
  'type': ActionTypes.ACTIVATE_ORIGIN_EDIT,
  'payload': originObject,
});

export const desactivateOrigin = () => ({
  'type': ActionTypes.DESACTIVATE_ORIGIN_EDIT,
  'payload': null,
});

export const uploadOrderFile = (originObject) => ({
  'type': ActionTypes.UPLOAD_ORDER_FILE,
  'payload': originObject,
});

export const removeOrderFile = () => ({
  'type': ActionTypes.REMOVE_ORDER_FILE,
  'payload': null,
});

export const uploadRawOrderFile = (originObject) => ({
  'type': ActionTypes.UPLOAD_ORDER_RAW_FILE,
  'payload': originObject,
});

export const removeRawsOrderFile = () => ({
  'type': ActionTypes.REMOVE_ORDER_RAWFILE,
  'payload': null,
});

export const setValidOrderTrue = () => ({
  'type': ActionTypes.SET_VALID_ORDER_TRUE,
  'payload': true,
});

export const setValidOrderFalse = () => ({
  'type': ActionTypes.SET_VALID_ORDER_FALSE,
  'payload': false,
});

export const setOrderPrice = (row) => ({
  'type': ActionTypes.SET_CREATE_ORDER_PRICE,
  'payload': row,
});

export const setOrder = (row) => ({
  'type': ActionTypes.SET_ORDER,
  'payload': row,
});

export const addNotificationOrder = (object) => ({
  'type': ActionTypes.ADD_NOTIFICATION_ORDER,
  'payload': object,
});

export const setOrderProcessedData = (orderObject) => ({
  'type': ActionTypes.SET_ORDER_PROCESSED_DATA,
  'payload': orderObject,
});

export const cleanCreateOrder = () => ({
  'type': ActionTypes.CLEAN_CREATE_ORDER,
  'payload': null,
});

export const addTempOrder = (order) => ({
  'type': ActionTypes.ADD_TEMP_ORDER,
  'payload': order,
});

export const removeTempOrder = (orderId) => ({
  'type': ActionTypes.REMOVE_TEMP_ORDER,
  'payload': orderId,
});

export const updateTempOrder = (order) => ({
  'type': ActionTypes.UPDATE_TEMP_ORDER,
  'payload': order,
});

export const cleanTempOrder = () => ({
  'type': ActionTypes.CLEAN_TEMP_ORDER,
  'payload': null,
});

export const setShowShipmentHeader = (value) => ({
  'type': ActionTypes.SET_SHOW_SHIPMENT_HEADER,
  'payload': value,
});

export const setShowShipmentHeaderShip = (value) => ({
  'type': ActionTypes.SET_SHOW_SHIPMENT_HEADER_SHIP,
  'payload': value,
});

export const setShipmentHeader = (keyValue, value) => ({
  'type': ActionTypes.SET_SHIPMENT_VALUES,
  'payload': {keyValue, value},
});

export const setOrderFromShipment = (row) => ({
  'type': ActionTypes.SET_ORDER_FROM_SHIPMENT_TABLE,
  'payload': row,
});

export const setCleanShipmentHeader = () => ({
  'type': ActionTypes.CLEAN_SHIPMENT_HEADER,
  'payload': null,
});

export const setUpdateShipmentHeader = (value) => ({
  'type': ActionTypes.SET_UPDATE_SHIPMENT_HEADER,
  'payload': value,
});

export const updateShipmentTable = (order) => ({
  'type': ActionTypes.UPDATE_SHIPMENT_TABLE,
  'payload': order,
});

export const cleanShipmentTable = () => ({
  'type': ActionTypes.CLEAN_SHIPMENT_TABLE,
  'payload': null,
});
